// extracted by css-extract-rspack-plugin
export default {"defaultStyles":"DiffFind-module__defaultStyles__rOHC89n"};